'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FiFromStrategy from './components/FiFromStrategy'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'
import TravelWhyChoose from './components/TravelWhyChoose'
import TopNotch from './components/TopNotch'
import BoostYourReal from './components/BoostYourReal'

const faqData = [
   {
      question: "How may real estate software development help my business? What is it?",
      answer:
         "It’s about building whatever digital tools you need to run your real estate business more smoothly. That could mean a site to list properties, a way to keep track of clients, or something to help move deals along without all the usual hassle.",
   },
   {
      question: "What features should a real estate software solution include?",
      answer:
         "A solid real estate software would include property searching and listing control, AI suggestions, virtual home tours, mortgage calculators, CRM integration, online scheduling, and safe payments.",
   },
   {
      question: "How does AI and big data improve real estate software?",
      answer:
         "Big data and AI facilitate predictive property valuation analytics, market trend projection, tailored recommendations, and automate lead management so that businesses make informed decisions using data and boost sales.",
   },
   {
      question:
         "Can real estate software integrate with MLS platforms and third-party applications?",
      answer:
         "MLS platforms, CRM systems, mortgage calculators, ERP programs, payment gateways, and marketing tools can all be easily integrated with real estate software to improve operational efficiency.",
   },
   {
      question: "How does blockchain technology enhance security in real estate transactions?",
      answer:
         "It locks down transactions with smart contracts, verifies identities, and records everything on a shared ledger, so deals are secure, clear, and much harder to mess with or fake.",
   },
   {
      question: "What are the benefits of a real estate mobile app for property buyers and sellers?",
      answer:
         "You can search listings fast, get alerts when something new pops up, message agents directly, run mortgage estimates, and even tour places virtually — all in one app.",
   },
   {
      question: "How much does it cost to develop a real estate software solution?",
      answer:
         "Cost for real estate software development varies by features, complexity, integrations, and platform support. A simple solution can be low-cost, but AI-driven, highly tailored platforms can be costly. Exact costs are defined based on project size and business objectives.",
   },
   {
      question: "What types of real estate businesses can benefit from custom software solutions?",
      answer:
         "Anyone working in real estate really. If you work in real estate, whether that is rentals, sales, lending, or something else, having software that fits how you actually work just makes things easier day to day.",
   },
   {
      question: "How much time does it take to create a software program for real estate?",
      answer:
         "Development times vary between 3 and 9 months based on complexity, integrations, and distinct business needs of the software.",
   },
   {
      question: "Why choose Benzatine for real estate software development?",
      answer:
         "Benzatine offers AI-driven, cloud-based, and blockchain-protected real estate solutions with seamless MLS integrations, predictive analytics, and tailored features to meet your business requirements.",
   },
];

function RealeStatePage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />

         <TopNotch />
         <FiFromStrategy />
         <BoostYourReal />

         <TravelWhyChoose />

         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default RealeStatePage
